// /src/services/Storage.js
export const apiRequests = function(configs) {
  const requests = []
  Object.entries(configs).forEach(([key, item]) => {
    if (item.hasOwnProperty('apiPath')) requests.push(item)
  })
  return requests
}

export const varData = function(configs) {
  const requests = []
  Object.entries(configs).forEach(([key, item]) => {
    if (item.hasOwnProperty('data')) requests.push(item)
  })
  return requests
}

export const pStore = {}
pStore.configs = {
  courses: {
    type: 'object',
    learningType: 'course',
    title: 'Course',
    titlePlural: 'Courses',
    storeKey: 'courses',
    routePath: 'courses',
    apiPath: 'courses',
    stateCommit: 'SET_COURSES',
    // data: phpCourses,
  },
  sessions: {
    type: 'object',
    learningType: 'session',
    title: 'Session',
    titlePlural: 'Sessions',
    storeKey: 'sessions',
    apiPath: 'sessions',
    routePath: 'sessions',
    stateCommit: 'SET_SESSIONS',
    // data: phpSessions,
  },
  relationships: {
    type: 'object',
    learningType: 'relationships',
    title: 'Relationship',
    titlePlural: 'Corporate Relationships',
    storeKey: 'relationships',
    apiPath: 'relationships',
    routePath: 'relationships',
    stateCommit: 'SET_RELATIONSHIPS',
    // data: phpSessions,
  },
  // bibleStudies: {
  //   type: 'object',
  //   learningType: 'bible-studies',
  //   title: 'Bible Study',
  //   titlePlural: 'Bible Studies',
  //   storeKey: 'bibleStudies',
  //   apiPath: 'bible-studies',
  //   routePath: 'bible-studies',
  //   stateCommit: 'SET_BIBLE_STUDIES',
  //   // data: phpBibleStudies,
  // },
  funnelLanding: {
    type: 'object',
    learningType: 'funnelLandings',
    title: 'Funnel Landing',
    titlePlural: 'Funnel Landings',
    storeKey: 'funnelLandingPages',
    apiPath: 'funnel-landing',
    routePath: 'funnel-landing',
    stateCommit: 'SET_FUNNEL_LANDING_PAGES'
  },
  funnels: {
    type: 'object',
    learningType: 'funnels',
    title: 'Dashboard',
    titlePlural: 'Dashboards',
    storeKey: 'funnels',
    routePath: 'dashboard',
    // apiPath: 'courses',
    stateCommit: 'SET_FUNNELS',
    data: funnel_dashboards,
  },
}
pStore['apiRequests'] = apiRequests(pStore.configs)
pStore['varData'] = varData(pStore.configs)

export const optionsStore = {}
// figure out why featured relationships thows errors in production. Removing for demo
optionsStore.configs = {
  // featuredRelationships: {
  //   type: 'object',
  //   option: 'featured-relationships',
  //   title: 'Featured',
  //   titlePlural: 'Featured Relationships',
  //   storeKey: 'featuredRelationships',
  //   apiPath: 'featured-relationships',
  //   routePath: 'featured-relationships',
  //   stateCommit: 'SET_FEATURED_RELATIONSHIPS',
  //   postKey: 'relationships',
  //   // data: phpSessions,
  // },
  departments: {
    type: 'object',
    option: 'departments',
    title: 'Departments',
    storeKey: 'departments',
    // apiPath: 'departments',
    routePath: 'departments',
    stateCommit: 'SET_DEPARTMENTS',
    // postKey: 'departments',
    data: departments,
  },
  resources: {
    type: 'object',
    option: 'global-resources',
    title: 'Global Resources',
    storeKey: 'global-resources',
    // apiPath: 'global-resources',
    routePath: 'global-resources',
    stateCommit: 'SET_GLOBAL_RESOURCES',
    data: globalResources,
  },
  primaryMenuLinks: {
    type: 'object',
    option: 'primaryMenu',
    title: 'Primary Menu',
    storeKey: 'primary-menu',
    // apiPath: 'global-resources',
    // routePath: 'global-resources',
    stateCommit: 'SET_PRIMARY_MENU_LINKS',
    data: primaryMenuLinks,
  },
}
optionsStore['apiRequests'] = apiRequests(optionsStore.configs)
optionsStore['varData'] = varData(optionsStore.configs)

// export const tStore = {}
// tStore.configs = {
//   authors: {
//     type: 'object',
//     storeKey: 'authors',
//     apiPath: 'authors',
//     routePath: 'authors',
//     title: 'Author',
//     titlePlural: 'Authors',
//     stateCommit: 'SET_AUTHORS',
//   },
//   categories: {
//     type: 'array',
//     title: 'Category',
//     titlePlural: 'Categories',
//     storeKey: 'categories',
//     routePath: 'categories',
//     apiPath: 'categories',
//     stateCommit: 'SET_CATEGORIES',
//   },
//   'deal-phases': {
//     type: 'object',
//     title: 'Deal Phase',
//     titlePlural: 'Deal Phases',
//     storeKey: 'dealPhases',
//     routePath: 'deal-phases',
//     apiPath: 'deal-phases',
//     stateCommit: 'SET_DEAL_PHASES',
//   },
//   origins: {
//     type: 'object',
//     title: 'Origin',
//     titlePlural: 'Origins',
//     storeKey: 'origins',
//     apiPath: 'origin',
//     routePath: 'origins',
//     stateCommit: 'SET_ORIGINS',
//   },
//   tags: {
//     type: 'object',
//     title: 'Keyword',
//     titlePlural: 'Keywords',
//     storeKey: 'tags',
//     apiPath: 'tags',
//     routePath: 'tags',
//     stateCommit: 'SET_TAGS',
//   },
//   tools: {
//     type: 'object',
//     title: 'Tools or System Type',
//     titlePlural: 'Tools or Systems',
//     storeKey: 'tools',
//     apiPath: 'tools',
//     routePath: 'tools',
//     stateCommit: 'SET_TOOL_TAX',
//   },
//   verticals: {
//     type: 'object',
//     title: 'Vertical',
//     titlePlural: 'Verticals',
//     storeKey: 'verticals',
//     routePath: 'verticals',
//     apiPath: 'verticals',
//     stateCommit: 'SET_VERTICALS',
//   },
// }
// tStore['apiRequests'] = apiRequests(tStore.configs)

export const mStore = {}
mStore.configs = {
  // images: {
  //   type: 'object',
  //   title: 'Image',
  //   titlePlural: 'Images',
  //   storeKey: 'images',
  //   apiPath: 'media',
  //   routePath: 'images',
  //   defaultArgs: {
  //     media_type: 'image',
  //   },
  //   stateCommit: 'SET_IMAGES',
  // },
  // audio: {
  //   type: 'object',
  //   title: 'Audio',
  //   titlePlural: 'Audios',
  //   storeKey: 'audios',
  //   apiPath: 'media',
  //   routePath: 'audios',
  //   defaultArgs: {
  //     media_type: 'audio',
  //   },
  //   stateCommit: 'SET_AUDIOS',
  // },
  downloads: {
    type: 'object',
    title: 'Download File',
    titlePlural: 'Downloads',
    storeKey: 'downloads',
    apiPath: 'media',
    routePath: 'downloads',
    // defaultArgs: {
    //   media_type: 'application',
    // },
    stateCommit: 'SET_DOWNLOADS',
  },
}
mStore['apiRequests'] = apiRequests(mStore.configs)

// export const fStore = {}
// fStore.configs = {
//   forms: {
//     type: 'object',
//     title: 'Download File',
//     titlePlural: 'Downloads',
//     storeKey: 'downloads',
//     apiPath: 'media',
//     routePath: 'downloads',
//     stateCommit: 'GET_FORMS',
//   },
// }
// fStore['apiRequests'] = apiRequests(fStore.configs)
